export default {
  faqGiftcard: {
    sections: [
      {
        title: 'FAQ about our gift card',
        questions: [
          {
            question: 'What is the konfetti gift card?',
            answer:
              'The konfetti gift card is redeemable for {eventCount} unique courses and experiences throughout Germany and Austria. The voucher can be used for any of our courses.',
          },
          {
            question:
              'What makes the konfetti experience gift card so special?',
            answer:
              'With the konfetti gift card you are giving the gift of great experiences and a wonderful time that will be remembered for a long time. With {eventCount} experiences to choose from, there’s a gift for everyone.',
          },
          {
            question:
              'What occasions are best suited for the konfetti gift card?',
            answer:
              'The gift card can be given for any occassion. Whether it’s a birthday, Christmas, wedding, Mother’s Day or employee gift, the konfetti gift card is sure to bring a smile to anyone’s face.',
          },
          {
            question: 'How does ordering a gift card work?',
            answer:
              'Select the gift card and determine the value. In the shopping cart you can decide if you want to order the printed gift card as well. After you have completed your purchase, we will email you the digital voucher for you to print. If you choose the haptic gift card, we will send it to you by mail.',
          },
          {
            question: 'How do I redeem the voucher?',
            answer:
              'The voucher will be loaded with funds. Select an experience on gokonfetti.com for which you would like to use the gift card and enter the voucher code. You can either use the entire value of the voucher or keep the remaining credit for your next experience. If you select an event for which you do not have sufficient funds, you will be shown the remaining balance.',
          },
          {
            question: 'How long is the voucher valid?',
            answer:
              'The voucher is valid for 3 years from the date of purchase.',
          },
          {
            question: 'Can I book more than one course with the gift car',
            answer:
              'If your voucher covers the costs of the courses, you can book as many courses as you like. If there is not enough in your voucher, the remaining amount will be displayed in the shopping cart.',
          },
          {
            question:
              'What can I do if the course I want is no longer offered?',
            answer:
              "Sometimes a course has to be canceled because the instructor is unavailable due to illness or because the minimum number of students has not been reached. Of course, you have the option to register for another course. Just send an email to hallo{'@'}gokonfetti.com and we will find a solution together.",
          },
          {
            question: 'Is there a gift card?',
            answer:
              'You can purchase our high quality gift card with your voucher. The card is a real eye-catcher and guaranteed to bring joy!',
          },
          {
            question: 'What is the delivery time of the gift card?',
            answer:
              'We take the gift card to the post office on the same or next business day. The delivery time depends on the postal service. ',
          },
          {
            question: 'Are gift cards impersonal?',
            answer:
              'With the konfetti gift card you can give away a special experience as well as time together. This makes our gift voucher a very special and above all personal gift! Even if other vouchers seem impersonal at first glance, you certainly don not have to worry about that with the konfetti gift card. Who would not be happy about a unique experience or time together?',
          },
        ],
      },
    ],
  },
}
